import { action, createRequestTypes } from './base';

export const tenantActionTypes = {
  GET_TENANTS: createRequestTypes('GET_TENANTS'),
  GET_TENANT_BY_ID: createRequestTypes('GET_TENANT_BY_ID'),
  CREATE_TENANT: createRequestTypes('CREATE_TENANT'),
  DELETE_TENANT: createRequestTypes('DELETE_TENANT'),
  UPDATE_TENANT: createRequestTypes('UPDATE_TENANT'),
  CREATE_USER: createRequestTypes('CREATE_USER'),
  GET_USERS: createRequestTypes('GET_USERS'),
  GET_ORG_USERS: createRequestTypes('GET_ORG_USERS'),
  DELETE_USER: createRequestTypes('DELETE_USER'),
  GET_TENANT_ANALYTICS: createRequestTypes('GET_TENANT_ANALYTICS'),
  GET_TENANTS_CONFIGURATION: createRequestTypes('GET_TENANTS_CONFIGURATION'),
  UPDATE_TENANT_CONFIGURATION: createRequestTypes('UPDATE_TENANT_CONFIGURATION'),
};

/**
 * TenantActions class
 *
 * @param tenantId
 * @param startDate
 * @param endDate
 * @param roleId
 */
class TenantActions {
  /**
   * @param page
   * @param keyword
   * @param isVerified
   * @param orgId
   * @param limit
   * @param callback
   * @param tenantId
   * @return {{type: *}}
   */
  getTenants = (page, keyword, isVerified, orgId, limit, callback, tenantId) => action(tenantActionTypes.GET_TENANTS.REQUEST, {
    page,
    keyword,
    isVerified,
    orgId,
    limit,
    callback,
    tenantId,
  });

  /**
   *
   * @param getTenantsLoading
   * @return {{type: *}}
   */
  getTenantsLoading = (getTenantsLoading) => action(tenantActionTypes.GET_TENANTS.LOADING, {
    getTenantsLoading,
  })

  /**
   *
   * @param tenants
   * @return {{type: *}}
   */
  getTenantsSuccess = (tenants) => action(tenantActionTypes.GET_TENANTS.SUCCESS, {
    tenants,
  })

  /**
   *
   * @param tenantId
   * @return {{type: *}}
   */
  getTenantById = (tenantId) => action(tenantActionTypes.GET_TENANT_BY_ID.REQUEST, {
    tenantId,
  })

  /**
   *
   * @param getTenantByIdLoading
   * @returns {{type: *}}
   */
  getTenantByIdLoading = (getTenantByIdLoading) => action(tenantActionTypes.GET_TENANT_BY_ID.LOADING, {
    getTenantByIdLoading,
  })

  /**
   *
   * @param selectedTenant
   * @return {{type: *}}
   */
  getTenantByIdSuccess = (selectedTenant) => action(tenantActionTypes.GET_TENANT_BY_ID.SUCCESS, {
    selectedTenant,
  })

  /**
   *
   * @type {{type: *}}
   */
  createTenant = (payload, callback) => action(tenantActionTypes.CREATE_TENANT.REQUEST, {
    payload,
    callback,
  })

  /**
   *
   * @param createTenantLoading
   * @return {{type: *}}
   */
  createTenantLoading = (createTenantLoading) => action(tenantActionTypes.CREATE_TENANT.LOADING, {
    createTenantLoading,
  })

  /**
   *
   * @param createdTenant
   * @return {{type: *}}
   */
  createTenantSuccess = (createdTenant) => action(tenantActionTypes.CREATE_TENANT.SUCCESS, {
    createdTenant,
  })

  /**
   *
   * @param tenantId
   * @return {{type: *}}
   */
  deleteTenant = (tenantId) => action(tenantActionTypes.DELETE_TENANT.REQUEST, {
    tenantId,
  })

  /**
   *
   * @param deleteTenantLoading
   * @return {{type: *}}
   */
  deleteTenantLoading = (deleteTenantLoading) => action(tenantActionTypes.DELETE_TENANT.LOADING, {
    deleteTenantLoading,
  })

  /**
   * @param payload
   * @param history
   * @param callback
   * @return {{type: *}}
   */
  updateTenant = (payload, callback) => action(tenantActionTypes.UPDATE_TENANT.REQUEST, {
    payload,
    callback,
  })

  /**
   *
   * @param updateTenantLoading
   * @return {{type: *}}
   */
  updateTenantLoading = (updateTenantLoading) => action(tenantActionTypes.UPDATE_TENANT.LOADING, {
    updateTenantLoading,
  })

  /**
   *
   * @param updatedTenant
   * @return {{type: *}}
   */
  updateTenantSuccess = (updatedTenant) => action(tenantActionTypes.UPDATE_TENANT.SUCCESS, {
    updatedTenant,
  })

  /**
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  createUser = (payload, callback) => action(tenantActionTypes.CREATE_USER.REQUEST, {
    payload,
    callback,
  })

  /**
   *
   * @param createUserLoading
   * @return {{type: *}}
   */
  createUserLoading = (createUserLoading) => action(tenantActionTypes.CREATE_USER.LOADING, {
    createUserLoading,
  })

  /**
   *
   * @param createdUser
   * @return {{type: *}}
   */
  createUserSuccess = (createdUser) => action(tenantActionTypes.CREATE_USER.SUCCESS, {
    createdUser,
  })

  /**
   *
   * @param tenantId
   * @param roleId
   * @param permissionType
   * @param callback
   * @return {{type: *}}
   */
  getUsers = (tenantId, roleId, permissionType, callback) => action(tenantActionTypes.GET_USERS.REQUEST, {
    tenantId,
    roleId,
    permissionType,
    callback,
  })

  /**
   *
   * @param getUsersLoading
   * @return {{type: *}}
   */
  getUsersLoading = (getUsersLoading) => action(tenantActionTypes.GET_USERS.LOADING, {
    getUsersLoading,
  })

  /**
   *
   * @param users
   * @return {{type: *}}
   */
  getUsersSuccess = (users) => action(tenantActionTypes.GET_USERS.SUCCESS, {
    users,
  })

  /**
   * @param userId
   * @param tenantId
   * @return {{type: *}}
   */
  deleteUser = (userId, tenantId) => action(tenantActionTypes.DELETE_USER.REQUEST, {
    userId,
    tenantId,
  })

  /**
   *
   * @param deleteUserLoading
   * @return {{type: *}}
   */
  deleteUserLoading = (deleteUserLoading) => action(tenantActionTypes.DELETE_USER.LOADING, {
    deleteUserLoading,
  })

 getTenantsAnalytics = (startDate, endDate, tenantId) => action(tenantActionTypes.GET_TENANT_ANALYTICS.REQUEST, { startDate, endDate, tenantId })

 /**
  *
  * @param getTenantsAnalyticsLoading
  * @return {{type: *}}
  */
  getTenantsAnalyticsLoading = (getTenantsAnalyticsLoading) => action(tenantActionTypes.GET_TENANT_ANALYTICS.LOADING, {
    getTenantsAnalyticsLoading,
  })

  /**
   * @param tenantsAnalytics
   * @param users
   * @return {{type: *}}
   */
  getTenantsAnalyticsSuccess = (tenantsAnalytics) => action(tenantActionTypes.GET_TENANT_ANALYTICS.SUCCESS, {
    tenantsAnalytics,
  })

  /**
   * @param {*} tenantId
   * @param callback
   * @return
   */
  getTenantsConfiguration = (tenantId, callback) => action(
    tenantActionTypes.GET_TENANTS_CONFIGURATION.REQUEST, {
      tenantId, callback,
    },
  );

  /**
   *
   * @param getTenantsConfigurationLoading
   * @return {{type: *}}
   */
   getTenantsConfigurationLoading = (getTenantsConfigurationLoading) => action(
     tenantActionTypes.GET_TENANTS_CONFIGURATION.LOADING, {
       getTenantsConfigurationLoading,
     },
   )

   /**
    *
    * @param {*} tenantsConfiguration
    * @return
    */
   getTenantsConfigurationSuccess = (tenantsConfiguration) => action(
     tenantActionTypes.GET_TENANTS_CONFIGURATION.SUCCESS, {
       tenantsConfiguration,
     },
   )

   /**
    *
    * @param {*} payload
    * @param {*} callback
    * @return
    */
   updateTenantConfiguration = (payload, callback) => action(
     tenantActionTypes.UPDATE_TENANT_CONFIGURATION.REQUEST, {
       payload,
       callback,
     },
   )

   /**
    * @param updateTenantConfigurationLoading
    * @param updateTenantLoading
    * @return {{type: *}}
    */
   updateTenantConfigurationLoading = (
     updateTenantConfigurationLoading,
   ) => action(tenantActionTypes.UPDATE_TENANT_CONFIGURATION.LOADING, {
     updateTenantConfigurationLoading,
   })

  /**
   *
   * @param tenantIds
   * @returns {{type: *}}
   */
  getOrgUsers = (tenantIds, callback) => action(tenantActionTypes.GET_ORG_USERS.REQUEST, {
    tenantIds, callback,
  })

  /**
   *
   * @param getOrgUsersLoading
   * @returns {{type: *}}
   */
  getOrgUsersLoading = (getOrgUsersLoading) => action(tenantActionTypes.GET_ORG_USERS.LOADING, {
    getOrgUsersLoading,
  })

  /**
   *
   * @param orgUsers
   * @returns {{type: *}}
   */
  getOrgUsersSuccess = (orgUsers) => action(tenantActionTypes.GET_ORG_USERS.SUCCESS, {
    orgUsers,
  })
}
export default new TenantActions();
